module.exports = __webpack_public_path__ + "img/b18-1.0db831c4.jpg";